import { BlogBox, BlogGrid, BlogList, BlogSingleItems, EditRadios, TypeaheadItem } from "../../types/Miscellaneous";

// Blog Box List
export const blogBoxShadowList: BlogBox[] = [
  { id: 1, icon: "user", text: "Mark Jecno" },
  { id: 2, icon: "thumbs-up", text: "02 Hits" },
  { id: 3, icon: "ui-chat", text: "598 Comments" },
];

export const blogBoxListData: BlogList[] = [
  { id: 1, src: "2.jpg", date: "02", hits: "0 Hits" },
  { id: 2, src: "3.jpg", date: "03", hits: "02 Hits" },
];

//Blog Box Grid
export const blogBoxGridData: BlogGrid[] = [
  {
    id: 1,
    image: "5.jpg",
  },
  {
    id: 2,
    image: "6.jpg",
  },
  {
    id: 3,
    image: "5.jpg",
  },
  {
    id: 4,
    image: "6.jpg",
  },
];

// Blog single
export const blogSingleData: BlogSingleItems[] = [
  { id: 1, src: "comment.jpg", name: "Jolio Mark", role: "Designer" },
  { id: 2, src: "9.jpg", name: "Thomas A. Deloach", role: "UX Designer" },
  { id: 3, src: "4.jpg", name: "John E. Cammack", role: "Designer" },
  { id: 4, src: "12.png", name: "Daniele G. Ferguson", role: "Designer" },
  { id: 5, src: "14.png", name: "Nathan C. Wilson", role: "Painter" },
];

export const singleBlogContent: string[] = ["From the east coast to the west, each river has its own beauty and character. Each river has its own story. Take a look at some America’s best rivers and some of the rivers we’re working to protect. And learn some facts about your favorite rivers. The Harpeth River and its tributaries are home to rich freshwater biodiversity, including more than 50 species of fish and 30 species of mussels.", "The Harpeth River flows through the heart of downtown Franklin, the 14th fastest growing city in the United States, and traverses Williamson County, one of the fastest growing counties in Tennessee. This rapid development has already caused harm to the river from adding treated sewage, increasing stormwater runoff, and withdrawing water.The river’s impairment is caused by dangerously low levels of dissolved oxygen driven by high concentrations of nutrients – particularly phosphorus – that fuel oxygen-hungry algal blooms that can lead to toxic conditions."];

//Add Post
export const dataTypeahead: TypeaheadItem[] = [{ name: "Lifestyle" }, { name: "Travel" }, { name: "Food" }, { name: "Beauty" }];

export const postEditRadios: EditRadios[] = [
  { id: 1, text: "Text" },
  { id: 2, text: "Image" },
  { id: 3, text: "Audio", check: "checked" },
  { id: 4, text: "Video" },
];
